import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { AzureCredentialsConfig } from './azure-credentials-config';

@Injectable({
  providedIn: 'root'
})
export class AzureCredentialsModalService extends BaseModalService<AzureCredentialsConfig> {}
